import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/AppSidebar";
import { TopBar } from "@/components/TopBar";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    /* `h-svh` Y NO EL `min-h-svh` QUE TRAE shadcn, y de eso depende que los
       paneles laterales queden fijos al scroll.

       Con `min-h-svh` el armazón crece con el contenido: `main` termina tan
       alto como su página —`scrollHeight === clientHeight`— y quien scrollea
       es la VENTANA. Pero `main` declara `overflow-auto`, así que para el
       navegador ES el contenedor de scroll más cercano; uno que nunca
       scrollea. Un `position: sticky` adentro se mide contra él y entonces no
       se activa NUNCA: el panel se va con la página como si la regla no
       estuviera escrita, y no hay nada en el CSS del panel que lo delate.
       Medido: al bajar 600 px el panel pasaba de 83 a -517.

       Con el alto fijo el armazón vuelve a ser lo que su propio markup ya
       declaraba —barra superior `shrink-0`, contenido con scroll propio,
       tarjeta de esquinas redondeadas y sombra— y el scroll ocurre dentro de
       `main`, que es lo único que hace funcionar al `sticky`. */
    <SidebarProvider className="bg-sidebar h-svh">
      <AppSidebar />
      {/* En desktop el main content redondea sus esquinas izquierdas (panel
          blanco sobre el sidebar gris). En mobile queda a ras (el redondeo se
          invierte hacia el cajón deslizable, ver ui/sidebar.tsx).

          Recorta con `overflow-clip` y NO con `overflow-hidden`: este último
          lo vuelve un contenedor de scroll sin barra, y lo que se escapa de
          `main` (un `sr-only`, el input oculto de un checkbox) le da de qué
          desplazarse. Un `scrollIntoView` hacia una tarjeta del final, con
          `main` ya en el fondo, lo movía: la barra de guardado subía y dejaba
          un hueco blanco debajo. `clip` recorta igual y no se puede mover. */}
      <SidebarInset className="flex flex-col md:overflow-clip md:rounded-l-[1.75rem] md:shadow-[-12px_0_40px_-20px_rgba(20,22,26,0.12)]">
        <TopBar />
        {/* `container-type: size` PARA QUE UN PANEL PEGAJOSO SEPA CUÁNTO ALTO
            TIENE DISPONIBLE, que es la mitad que falta del problema de arriba.
            Un panel más alto que la pantalla se pega arriba y deja su parte de
            abajo —el botón que cierra el paso— fuera del borde inferior, sin
            forma de alcanzarla: pegado no scrollea, y la página tampoco lo
            mueve.

            El tope tiene que salir del alto de ESTE contenedor, que es el que
            scrollea (la ventana menos la barra superior), y no de `100svh`,
            que se pasa justo por lo que mide la barra. Declarado el contenedor,
            `cqh` lo dice exacto y nadie tiene que estimar la barra a mano ni
            corregir la cuenta cuando el título de una pantalla ocupe dos
            renglones.

            Es `size` y no `inline-size` porque lo que se consulta es el ALTO.
            No pisa a los dos contenedores que ya existen en el DS (`card-header`
            y `field-group`): aquellos van NOMBRADOS y consultan el ancho. */}
        <main className="flex-1 overflow-auto [container-type:size]">
          {children}
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
